(function () {
  'use strict';
  class HBCountryClubVideo {
    constructor(container) {
      this.container = container;

      this.video =
        this.container.querySelector(
          '.hb-video__player video'
        );

      this.trigger =
        this.container.querySelector(
          '[data-hb-video-trigger]'
        );

      this.handlePlay =
        this.handlePlay.bind(this);

      this.handleVideoPlay =
        this.handleVideoPlay.bind(this);

      this.handleVideoEnded =
        this.handleVideoEnded.bind(this);

      this.handleVideoError =
        this.handleVideoError.bind(this);


      if (!this.video || !this.trigger) {
        return;
      }


      this.bindEvents();
    }
    bindEvents() {

      this.trigger.addEventListener(
        'click',
        this.handlePlay
      );


      this.video.addEventListener(
        'play',
        this.handleVideoPlay
      );


      this.video.addEventListener(
        'ended',
        this.handleVideoEnded
      );


      this.video.addEventListener(
        'error',
        this.handleVideoError
      );

    }

    handlePlay(event) {

      event.preventDefault();


      if (!this.video) {
        return;
      }
      this.container.classList.add(
        'is-playing'
      );
      const playPromise =
        this.video.play();
      if (
        playPromise &&
        typeof playPromise.catch === 'function'
      ) {

        playPromise.catch(() => {

          this.container.classList.remove(
            'is-playing'
          );

        });

      }

    }
    handleVideoPlay() {

      this.container.classList.add(
        'is-playing'
      );

    }
    handleVideoEnded() {
      this.container.classList.remove(
        'is-playing'
      );
      try {

        this.video.currentTime = 0;

      } catch (error) {
      }

    }
    handleVideoError() {
      this.container.classList.remove(
        'is-playing'
      );

    }
    destroy() {

      if (!this.video || !this.trigger) {
        return;
      }
      this.trigger.removeEventListener(
        'click',
        this.handlePlay
      );
      this.video.removeEventListener(
        'play',
        this.handleVideoPlay
      );
      this.video.removeEventListener(
        'ended',
        this.handleVideoEnded
      );
      this.video.removeEventListener(
        'error',
        this.handleVideoError
      );

    }

  }
  class HBCountryClubBackgroundVideo {
    constructor(section) {

      this.section = section;


      this.wrapper =
        this.section.querySelector(
          '.hb-club__background-video-wrapper'
        );


      this.video =
        this.wrapper
          ? this.wrapper.querySelector('video')
          : null;


      this.shouldAutoplay =
        this.video
          ? this.video.autoplay
          : false;


      this.isVisible =
        true;


      this.intersectionObserver =
        null;


      this.reducedMotionQuery =
        window.matchMedia
          ? window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            )
          : null;


      this.handleVisibilityChange =
        this.handleVisibilityChange.bind(this);


      this.handleReducedMotionChange =
        this.handleReducedMotionChange.bind(this);


      this.handleVideoError =
        this.handleVideoError.bind(this);


      if (!this.wrapper || !this.video) {
        return;
      }


      this.prepareVideo();

      this.bindEvents();

      this.initIntersectionObserver();

      this.updatePlayback();

    }
    prepareVideo() {
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.video.setAttribute(
        'playsinline',
        ''
      );


      this.video.setAttribute(
        'muted',
        ''
      );
      if (!this.video.controls) {

        this.video.setAttribute(
          'tabindex',
          '-1'
        );

        this.video.setAttribute(
          'aria-hidden',
          'true'
        );

      }

    }
    bindEvents() {

      document.addEventListener(
        'visibilitychange',
        this.handleVisibilityChange
      );


      this.video.addEventListener(
        'error',
        this.handleVideoError
      );


      if (this.reducedMotionQuery) {

        if (
          typeof this.reducedMotionQuery.addEventListener ===
          'function'
        ) {

          this.reducedMotionQuery.addEventListener(
            'change',
            this.handleReducedMotionChange
          );

        } else if (
          typeof this.reducedMotionQuery.addListener ===
          'function'
        ) {
          this.reducedMotionQuery.addListener(
            this.handleReducedMotionChange
          );

        }

      }

    }
    initIntersectionObserver() {

      if (
        !('IntersectionObserver' in window)
      ) {

        this.isVisible = true;

        return;
      }


      this.intersectionObserver =
        new IntersectionObserver(
          (entries) => {

            entries.forEach((entry) => {

              if (
                entry.target !==
                this.section
              ) {
                return;
              }


              this.isVisible =
                entry.isIntersecting;


              this.updatePlayback();

            });

          },
          {
            root: null,
            threshold: 0.05
          }
        );


      this.intersectionObserver.observe(
        this.section
      );

    }
    prefersReducedMotion() {

      return Boolean(
        this.reducedMotionQuery &&
        this.reducedMotionQuery.matches
      );

    }
    handleReducedMotionChange() {

      this.updatePlayback();

    }
    handleVisibilityChange() {

      this.updatePlayback();

    }
    canPlay() {
      if (!this.shouldAutoplay) {
        return false;
      }
      if (document.hidden) {
        return false;
      }
      if (!this.isVisible) {
        return false;
      }
      if (this.prefersReducedMotion()) {
        return false;
      }
      const wrapperStyle =
        window.getComputedStyle(
          this.wrapper
        );
      if (
        wrapperStyle.display === 'none' ||
        wrapperStyle.visibility === 'hidden'
      ) {
        return false;
      }
      return true;
    }
    updatePlayback() {

      if (!this.video) {
        return;
      }
      if (this.canPlay()) {
        this.play();

      } else {

        this.pause();

      }

    }
    play() {

      if (!this.video) {
        return;
      }
      if (
        !this.video.paused &&
        !this.video.ended
      ) {

        return;

      }
      this.video.muted = true;
      this.video.defaultMuted = true;
      const playPromise =
        this.video.play();
      if (
        playPromise &&
        typeof playPromise
          .then === 'function'
      ) {

        playPromise
          .then(() => {

            this.section.classList.add(
              'hb-club--background-video-playing'
            );


            this.section.classList.remove(
              'hb-club--background-video-blocked'
            );

          })

          .catch(() => {
            this.section.classList.remove(
              'hb-club--background-video-playing'
            );
            this.section.classList.add(
              'hb-club--background-video-blocked'
            );
          });
      }
    }
    pause() {

      if (!this.video) {
        return;
      }
      if (!this.video.paused) {

        try {

          this.video.pause();

        } catch (error) {
        }
      }
      this.section.classList.remove(
        'hb-club--background-video-playing'
      );
    }
    handleVideoError() {
      this.section.classList.remove(
        'hb-club--background-video-playing'
      );
      this.section.classList.add(
        'hb-club--background-video-error'
      );
    }
    handleResize() {

      this.updatePlayback();

    }
    destroy() {

      if (!this.video) {
        return;
      }
      this.pause();
      document.removeEventListener(
        'visibilitychange',
        this.handleVisibilityChange
      );
      this.video.removeEventListener(
        'error',
        this.handleVideoError
      );

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }
      if (this.reducedMotionQuery) {
        if (
          typeof this.reducedMotionQuery
            .removeEventListener ===
          'function'
        ) {

          this.reducedMotionQuery
            .removeEventListener(
              'change',
              this.handleReducedMotionChange
            );

        } else if (
          typeof this.reducedMotionQuery
            .removeListener ===
          'function'
        ) {

          this.reducedMotionQuery
            .removeListener(
              this.handleReducedMotionChange
            );

        }

      }

    }

  }

  class HBCountryClubSection {
    constructor(section) {
      this.section = section;
      this.cardVideos = [];
      this.backgroundVideo = null;
      this.handleResize =
        this.handleResize.bind(this);
      this.initialize();
    }
    initialize() {
      this.initializeCardVideos();
      this.initializeBackgroundVideo();
      window.addEventListener(
        'resize',
        this.handleResize,
        {
          passive: true
        }
      );
    }
    initializeCardVideos() {

      const containers =
        this.section.querySelectorAll(
          '[data-hb-video-container]'
        );
      containers.forEach(
        (container) => {
          const controller =
            new HBCountryClubVideo(
              container
            );
          this.cardVideos.push(
            controller
          );
        }
      );
    }
    initializeBackgroundVideo() {

      const wrapper =
        this.section.querySelector(
          '.hb-club__background-video-wrapper'
        );

      if (!wrapper) {
        return;
      }

      this.backgroundVideo =
        new HBCountryClubBackgroundVideo(
          this.section
        );

    }
    handleResize() {

      if (!this.backgroundVideo) {
        return;
      }
      window.clearTimeout(
        this.resizeTimer
      );

      this.resizeTimer =
        window.setTimeout(
          () => {

            this.backgroundVideo
              .handleResize();

          },
          100
        );

    }
    destroy() {

      window.removeEventListener(
        'resize',
        this.handleResize
      );

      window.clearTimeout(
        this.resizeTimer
      );
      this.cardVideos.forEach(
        (controller) => {

          if (
            controller &&
            typeof controller.destroy ===
            'function'
          ) {

            controller.destroy();

          }

        }
      );


      this.cardVideos = [];


      if (
        this.backgroundVideo &&
        typeof this.backgroundVideo.destroy ===
        'function'
      ) {

        this.backgroundVideo.destroy();

      }


      this.backgroundVideo = null;

    }

  }
  const countryClubControllers =
    new WeakMap();
  function initializeCountryClub(scope) {

    const root =
      scope instanceof Element ||
      scope instanceof Document
        ? scope
        : document;
    const sections = [];
    if (
      root instanceof Element &&
      root.matches(
        '[data-hb-country-club]'
      )
    ) {

      sections.push(root);

    }
    root
      .querySelectorAll(
        '[data-hb-country-club]'
      )
      .forEach(
        (section) => {

          sections.push(section);

        }
      );

    sections.forEach(
      (section) => {
        if (
          countryClubControllers.has(
            section
          )
        ) {

          return;

        }
        const controller =
          new HBCountryClubSection(
            section
          );


        countryClubControllers.set(
          section,
          controller
        );

      }
    );

  }

  function destroyCountryClub(section) {

    if (!section) {
      return;
    }


    let heroSection = null;


    if (
      section.matches &&
      section.matches(
        '[data-hb-country-club]'
      )
    ) {

      heroSection = section;

    } else {

      heroSection =
        section.querySelector
          ? section.querySelector(
              '[data-hb-country-club]'
            )
          : null;

    }


    if (!heroSection) {
      return;
    }


    const controller =
      countryClubControllers.get(
        heroSection
      );


    if (!controller) {
      return;
    }


    controller.destroy();


    countryClubControllers.delete(
      heroSection
    );

  }

  function initializePage() {

    initializeCountryClub(
      document
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializePage,
      {
        once: true
      }
    );

  } else {

    initializePage();

  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initializeCountryClub(
        event.target
      );

    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      destroyCountryClub(
        event.target
      );

    }
  );
  document.addEventListener(
    'shopify:block:select',
    function (event) {

      const section =
        event.target.closest
          ? event.target.closest(
              '[data-hb-country-club]'
            )
          : null;


      if (!section) {
        return;
      }


      const controller =
        countryClubControllers.get(
          section
        );


      if (
        controller &&
        controller.backgroundVideo
      ) {

        controller
          .backgroundVideo
          .updatePlayback();

      }

    }
  );

})();